import React, { forwardRef } from 'react';

import { Calendar, CalendarProps } from 'primereact/calendar';

import { DatePickerInput } from '@/components/ui/date-picker-input';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { cn } from '@/lib/utils';

export const CalendarWrapper = forwardRef<
  any,
  CalendarProps & {
    container?: React.ComponentProps<typeof DatePickerInput>['container'];
    id?: string;
    inputId?: string;
  }
>(
  (
    {
      value,
      onChange,
      id,
      inputId,
      placeholder,
      className,
      container,
      ...rest
    },
    ref,
  ) => {
    const isDatePickerInputEnabled = useFeatureFlag('DS_BDate_Entry');

    if (isDatePickerInputEnabled && !rest.timeOnly) {
      const initialDate = value instanceof Date ? value : undefined;

      const handleChange = (date: Date | null) => {
        if (onChange) {
          const event = { value: date, target: { value: date } };
          onChange(event as any);
        }
      };

      return (
        <DatePickerInput
          id={inputId || id}
          initialDate={initialDate}
          onChange={handleChange}
          placeholder={placeholder}
          className={cn(className)}
          container={container}
          tabIndex={rest.tabIndex}
          disabled={rest.disabled}
          inputRef={rest.inputRef}
          onBlur={rest.onBlur}
        />
      );
    }

    return (
      <Calendar
        ref={ref}
        value={value}
        onChange={onChange}
        id={id}
        inputId={inputId}
        placeholder={placeholder}
        {...rest}
      />
    );
  },
);

CalendarWrapper.displayName = 'CalendarWrapper';
